import { memo } from 'react'
import './styles.css'
import IconSearch from '../../assets/icons/search.svg'

const TextField = memo(function TextField({
  placeholder,
  value,
  onChange,
  type = 'text',
  className = '',
  withIcon = false,
  withPasswordToggle = false,
  showPassword = false,
  onTogglePassword,
  passwordToggleIcon,
  ...props
}) {
  if (withIcon) {
    return (
      <div className="text-field-container">
        <div className="text-field-with-icon">
          <input
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...props}
          />
          <img src={IconSearch} alt="" className="text-field-icon" />
        </div>
      </div>
    )
  }

  if (withPasswordToggle) {
    return (
      <div className="text-field-with-password-toggle">
        <input
          type={type}
          className={`text-field ${className}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
        {withPasswordToggle && onTogglePassword && passwordToggleIcon && (
          <button
            type="button"
            className="text-field-password-toggle"
            onClick={onTogglePassword}
            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          >
            {passwordToggleIcon}
          </button>
        )}
      </div>
    )
  }

  return (
    <input
      type={type}
      className={`text-field ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
    />
  )
})

export default TextField
